const works = [
  {
    title: "5 Dollars for 3 Minutes",
    component: "FiveDollarsThreeMinutes",
  },  
  {
    title: "秋雲, Autumn Cloud",
    component: "AutumnCloud",
  },
  {
    title: "Soft Furnishing",
    component: "SoftFurnishing",
  },
     
  {
    title: "Almost Something",
    component: "AlmostSomething",
  },
  {
      title: "Valley of the Dolls",
      component: "ValleyOfTheDolls",
    },
    {
      title: "Morena",
      component: "Morena",
    },
  ];
  
  export default works;
  